import { PathService } from './../../../service/canvas/path.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { buttonSize, buttonVariant } from '@models/button-options.enum';
import {
    EditorEntityItem,
    ElementAttribute,
    canvasEditorOptions,
    connectorItemList,
    controlItemList,
    drawItemList,
    editorFunctionOptionList,
    functionLables,
    shapeItemList,
} from '@models/editor';
import { CanvasInputMode, CanvasInputModeService } from '@service/canvas/canvas-input-mode.service';
import { CanvasService } from '@service/canvas/canvas.service';
import { PasteService } from '@service/canvas/paste.service';
import { SelectedElementsService } from '@service/canvas/selected-elements.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-footer-buttons',
    templateUrl: './footer-buttons.component.html',
    styleUrls: ['./footer-buttons.component.css'],
    standalone: false,
})
export class FooterButtonsComponent implements OnInit, OnDestroy {
    @Input() selectedMimic;
    currentMode: CanvasInputMode;
    selectedElements: any;
    isLoading: boolean = false;

    readonly BUTTON_SMALL_SIZE = buttonSize.small;
    readonly BUTTON_TEXT = buttonVariant.text;

    readonly TEXT_OPTION = canvasEditorOptions.text;

    readonly DRAW_ITEM_LIST = drawItemList;
    readonly CONNECTOR_ITEM_LIST = connectorItemList;
    readonly CONTROL_ITEM_LIST = controlItemList;
    readonly SHAPE_ITEM_LIST = shapeItemList;
    readonly FUNCTION_LIST = editorFunctionOptionList;

    constructor(
        private canvasModeService: CanvasInputModeService,
        private selectionService: SelectedElementsService,
        private canvasService: CanvasService,
        private pasteService: PasteService,
        private pathService: PathService
    ) {}

    private destroySubscriptionSubject$ = new Subject<void>();
    ngOnInit(): void {
        this.canvasModeService
            .onModeChanged()
            .pipe(takeUntil(this.destroySubscriptionSubject$))
            .subscribe(mode => {
                this.currentMode = mode;
            });

        this.selectionService
            .onElementsSelected()
            .pipe(takeUntil(this.destroySubscriptionSubject$))
            .subscribe(selectedElements => {
                this.selectedElements = selectedElements;
            });
    }

    ngOnDestroy(): void {
        this.destroySubscriptionSubject$.next();
        this.destroySubscriptionSubject$.complete();
    }

    async setMode(mode) {
        if (!this.selectedMimic) {
            return;
        }
        if (mode === CanvasInputMode.GROUP_SELECTED) {
            (this.canvasService.getCanvas() as any).groupSelectedElements();
            return;
        } else if (mode === CanvasInputMode.UNGROUP_SELECTED) {
            (this.canvasService.getCanvas() as any).ungroupSelectedElement();
            this.selectionService.setSelectedElements([]);
            this.canvasModeService.setMode(CanvasInputMode.SELECT);
            return;
        } else if (mode === CanvasInputMode.DUPLICATE) {
            this.isLoading = true;
            try {
                await this.pasteService.duplicateElements();
            } catch (err) {
                console.error(err);
            }
            this.isLoading = false;
            return;
        }
        this.selectionService.setSelectedElements([]);
        if (this.canvasModeService.getMode() == CanvasInputMode.PATH && mode !== CanvasInputMode.PATH) {
            this.pathService.finishPath();
        }
        this.canvasModeService.setMode(mode);
    }

    dropDownChange(entitiyItem: EditorEntityItem) {
        this.setMode(entitiyItem.name);
    }

    shouldShowIcon(functionItem) {
        if (
            functionItem.name == functionLables.move ||
            functionItem.name == functionLables.duplicate ||
            functionItem.name == functionLables.grab
        ) {
            return true;
        } else if (functionItem.name == functionLables.group && this.selectedElements?.length > 1) {
            return true;
        } else if (
            functionItem.name == functionLables.ungroup &&
            this.selectedElements?.length === 1 &&
            this.selectedElements[0]?.tagName === 'g'
        ) {
            const icreateType = this.selectedElements[0].getAttribute(ElementAttribute.iCreateType);
            const type = this.selectedElements[0].getAttribute(ElementAttribute.type);
            const connectorType = this.selectedElements[0].getAttribute(ElementAttribute.connectorType);
            return !type && !icreateType && !connectorType;
        }

        return false;
    }
}
